import { browserHistory } from "react-router"
import HierarchySettingsStore from "../stores/HierarchySettingsStore"
import AuthenticationStore from "../stores/AuthenticationStore"
import * as permissionHelper from "./permissionHelper"
import * as hierarchyHelper from "./hierarchyHelper"
const allHierarchySubMenuItems = ["details", "children", "users", "employees", "positions", "location", "records", "devices", "settings"]


export function getHierarchySubMenuItems(isRoot, explicitAccountUserHierarchyAssignment, explicitEmployeeHierarchyAssignment, selectedItem, selectedHierarchy) {
    let hierarchySubMenuItems = allHierarchySubMenuItems.slice()
    if (isRoot) {
        //---- hide the device tab until mobile is ready
        //hierarchySubMenuItems = ['children', 'devices', 'settings'];
        hierarchySubMenuItems = ["details", "children", "settings"]
        if (selectedHierarchy && !HierarchySettingsStore.getGlobalLevelItemFilterId() && hierarchySubMenuItems.indexOf(selectedItem) === -1) {
            browserHistory.push("/hierarchy/" + hierarchySubMenuItems[0])
        }
    } else {
        const currentHierarchyDefinition = hierarchyHelper.getHierarchyDefinitionByHierarchyItemId(HierarchySettingsStore.getGlobalLevelItemFilterId())
        if (explicitAccountUserHierarchyAssignment === false) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("users"), 1)
        } else if (currentHierarchyDefinition && !currentHierarchyDefinition.EnableAccountUsers) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("users"), 1)
        }
        if (explicitEmployeeHierarchyAssignment === false || !permissionHelper.hasPermission(AuthenticationStore.Permissions.Employees.ViewEmployees)) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("employees"), 1)
        } else if (currentHierarchyDefinition && !currentHierarchyDefinition.EnableEmployees) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("employees"), 1)
        }
        if (currentHierarchyDefinition && !currentHierarchyDefinition.EnablePositions) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("positions"), 1)
        }
        if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.PunchRecords.ViewRecords)) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("records"), 1)
        }

        if (!permissionHelper.hasPermission(AuthenticationStore.Permissions.Devices.ViewHierarchyDevices)) {
            hierarchySubMenuItems.splice(hierarchySubMenuItems.indexOf("devices"), 1)
        }
        if (selectedHierarchy && hierarchySubMenuItems.indexOf(selectedItem) === -1) {
            browserHistory.push("/hierarchy/" + hierarchySubMenuItems[0])
        }
    }
    return hierarchySubMenuItems
}
